import { setItem } from '@/utils/storage';

export const mutations = {
  SET_CANDIDATES_MODE: (state, mode) => {
    state.candidatesMode = mode;
    setItem('candidatesMode', mode);
  }
};
